import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "elements__Container",
  componentId: "sc-1k96ciw-0"
})(["position:relative;"]);
export var DatePickerWrapper = styled.div.withConfig({
  displayName: "elements__DatePickerWrapper",
  componentId: "sc-1k96ciw-1"
})(["padding:1.5rem;background:white;"]);
export var PopoverContainer = styled.div.withConfig({
  displayName: "elements__PopoverContainer",
  componentId: "sc-1k96ciw-2"
})(["position:absolute;"]);